export const friendsRewards = (
  amountByReferred: number,
  maxProfitThreshold: number
): { title?: string; amount: string }[] => [
  {
    title: `1 amigo`,
    amount: `$${amountByReferred}`,
  },
  {
    title: '2 amigos',
    amount: `$${amountByReferred * 2}`,
  },
  {
    amount: '.',
  },
  {
    amount: '.',
  },
  {
    amount: '.',
  },
  {
    amount: '.',
  },
  {
    amount: '.',
  },
  {
    title: `${maxProfitThreshold} amigos`,
    amount: ` 🎉 $${amountByReferred * maxProfitThreshold}  🎉`,
  },
];
